import { render } from "./Index.vue?vue&type=template&id=85fcea56&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=85fcea56&land=css&lang=css"
import "./Index.vue?vue&type=style&index=1&id=85fcea56&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85fcea56"]])

export default __exports__